/*
 * Global soft scroll-reveal for arpy.
 * Fades section content up as it enters view, site-wide.
 * - Skips pages that already have their own inline animations (home / our-range / product pages).
 * - Only touches <main> content (never header or footer).
 * - Leaves anything already on screen at load visible (no flash); only animates what you scroll to.
 * - Respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var skip = '.arpy-home, .arpy-range, .arpy-product';
    var set = new Set();

    // Custom arpy landings (about, faq, contact, policies, search, 404): reveal each section block.
    document.querySelectorAll('main [class*="arpy-"][class*="-section"]').forEach(function (el) {
      if (!el.closest(skip)) set.add(el);
    });
    // Standard theme pages: reveal each section that isn't a custom arpy build.
    document.querySelectorAll('main .shopify-section').forEach(function (sec) {
      if (!sec.querySelector('[class*="arpy-"]')) set.add(sec);
    });

    var els = Array.from(set);
    if (!els.length) return;

    var style = document.createElement('style');
    style.textContent =
      '.arpy-reveal{opacity:0;transform:translateY(16px);' +
      'transition:opacity .7s cubic-bezier(.25,.46,.45,.94),transform .7s cubic-bezier(.25,.46,.45,.94);}' +
      '.arpy-reveal.arpy-reveal-in{opacity:1;transform:none;}';
    document.head.appendChild(style);

    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('arpy-reveal-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' })
      : null;

    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      // Already on screen at load -> leave visible (avoids any flash on above-the-fold content).
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('arpy-reveal');
      if (io) io.observe(el); else el.classList.add('arpy-reveal-in');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
